import React from 'react';

import AssociationMembers from 'screens/associations/AssociationMembers';
import AssociationAdminWrapper from 'screens/associations/components/AssociationAdminWrapper';

const AssociationMembersScreen = () => <AssociationMembers />;

export default AssociationMembersScreen;

AssociationMembersScreen.getLayout = (page) => (
  <AssociationAdminWrapper>{page}</AssociationAdminWrapper>
);
